<template>
  <div class="content"> 
    
    <h3>Visual Privacy: From Experimental Psychology to Computational Modeling.</h3>
    <p>Privacy concerns with social media have recently been under the spotlight, due to a few incidents on user data leakage on social networking platforms. With the current advances in machine learning and big data, computer algorithms often act as a first-step filter for privacy breaches, by automatically selecting content with sensitive information, such as photos that contain faces or vehicle license plate. In this paper we propose a novel algorithm to protect the sensitive attributes against machines, meanwhile keeping the changes imperceptible to humans. In particular, we first conducted a series of human studies to investigate multiple factors that influence human sensitivity to the visual changes. We discover that human sensitivity is influenced by multiple factors, from low-level features such as illumination, texture, to high-level attributes like object sentiment and semantics. Based on our human data analyses, we propose a human-sensitivity-aware image perturbation model, which is able to modify the computational classification results of sensitive attributes while preserving the remaining attributes. Experiments on real world data demonstrate the superior performance of the proposed model on human-imperceptible privacy protection.</p>
    
    <b-card>
      <h5>News</h5>
      > Our paper "Human-imperceptible Privacy Protection Against Machines" has been accepted by <strong>ACM Multimedia 2019</strong> as <span style="color:red;">Best student paper</span>.
      <br>See <router-link to="/publication">here</router-link> for more details.

      <br>
      <br>
      <strong>Dataset:</strong>
      We use <strong>EMOd dataset</strong> for experiment and evaluation.
      <br>You can find this dataset from <router-link to="/dataset">here</router-link>.

      <br>
      <br>
      <strong>Experiment:</strong>
      We have deployed a <strong>live demo</strong> of our experiment.
      <br> if you are interested, please see more details from <router-link to="/experiment">here</router-link>.


      <br>
      <br>
      <strong>Code:</strong>
      The code is developed on tensorflow and keras.
      <br>  See <router-link to="/code">here</router-link> for more details.

      <br>
      <br>
      <h5>Authors</h5>
      <strong>Zhiqi Shen</strong> 
      &nbsp;&nbsp; [<a href="https://ncript.comp.nus.edu.sg/site/homepage/zhiqi/">Home Page</a>]
      &nbsp;&nbsp; [<a href="https://scholar.google.com.sg/citations?user=FYUEZ3wAAAAJ&hl=en">Google Scholar</a>]
      <br>
      <strong>Shaojing Fan</strong> 
      &nbsp;&nbsp; [<a href="https://sites.google.com/site/fanshaojing/">Home Page</a>]
      &nbsp;&nbsp; [<a href="https://scholar.google.com.sg/citations?user=4ORJkywAAAAJ&hl=en">Google Scholar</a>]
      <br>
      <strong>Yongkang Wong</strong>
      &nbsp;&nbsp; [<a href="https://scholar.google.com/citations?user=Xa0mxggAAAAJ&hl=zh-CN">Google Scholar</a>]
      <br>
      <strong>Tian-Tsong Ng</strong>
      &nbsp;&nbsp; [<a href="https://scholar.google.com/citations?user=rDCn7yEAAAAJ&hl=en">Google Scholar</a>]
      <br>
      <strong>Mohan Kankanhalli</strong>
      &nbsp;&nbsp; [<a href="https://www.comp.nus.edu.sg/~mohan/">Home Page </a>]
      &nbsp;&nbsp; [<a href="https://scholar.google.co.uk/citations?user=6Lx_eowAAAAJ&hl=en">Google Scholar</a>]
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components:{
  }
}
</script>

<style scoped>

</style>
